module.exports = __webpack_public_path__ + "static/img/sensorlight.53c20ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/side-menu/sensorlight.png
// module id = pfZb
// module chunks = 1